import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { STATIC_PAGES } from '../../../../../utils/helpers/constants';
import { Button } from '../../../../ui/Button';
import { StyledLink, Terms, TermsAndConditionContainer } from './styled';
import useScreenSize from '../../../../../hooks/useScreenSize';
import { generateDataStat } from '../../../../../utils/helpers/generateDataStat';
import { useClient } from '../../../../../hooks/useClient';

interface TermsAndConditionProps {
  onSubmit: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  buttonCypress: string;
}

export const TermsAndCondition: React.FC<TermsAndConditionProps> = ({
  onSubmit,
  isLoading,
  isDisabled,
  buttonCypress
}) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const agreement = t('authentication.agreement');
  const rules = t('new_ad.rules');

  return (
    <TermsAndConditionContainer>
      <Button
        text={t('new_ad.continue')}
        onClick={onSubmit}
        loading={isLoading}
        disabled={isLoading || isDisabled}
        stat={generateDataStat('create_ad_step4_continue', isSmall, isClient)}
        cypress={buttonCypress}
        type="button"
      />

      <Terms data-cy="form-terms" tag="body_2">
        <Trans i18nKey="new_ad.confirmation" values={{ agreement, rules }}>
          <StyledLink href={STATIC_PAGES.TERMS} data-cy="item-form-terms">
            {{ agreement }}
          </StyledLink>
          <StyledLink href={STATIC_PAGES.RULES} data-cy="item-form-rules">
            {{ rules }}
          </StyledLink>
        </Trans>
      </Terms>
    </TermsAndConditionContainer>
  );
};
